import * as i0 from '@angular/core';
import * as i1 from './datepicker.module';
import * as i2 from '@angular/cdk/bidi';
import * as i3 from '@angular/cdk/scrolling';
import * as i4 from '@angular/cdk/overlay';
import * as i5 from '@angular/cdk/portal';
import * as i6 from '../cdk/overlay/mapping';
import * as i7 from '../cdk/overlay/overlay-container';
import * as i8 from '../calendar/calendar.component';
import * as i9 from '../calendar/calendar-range.component';
import * as i10 from './datepicker.directive';
import * as i11 from './datepicker-container.component';
import * as i12 from './datepicker.component';
import * as i13 from '../cdk/overlay/overlay.module';
import * as i14 from '../calendar/calendar.module';
import * as i15 from '../calendar/calendar-range.module';
export const ElDatepickerModuleNgFactory:i0.NgModuleFactory<i1.ElDatepickerModule> = (null as any);
var _decl0_0:i2.Dir = (<any>(null as any));
var _decl0_1:i3.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_2:i3.CdkScrollable = (<any>(null as any));
var _decl0_3:i3.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_4:i3.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_5:i4.CdkConnectedOverlay = (<any>(null as any));
var _decl0_6:i4.CdkOverlayOrigin = (<any>(null as any));
var _decl0_7:i5.CdkPortal = (<any>(null as any));
var _decl0_8:i5.CdkPortalOutlet = (<any>(null as any));
var _decl0_9:i6.ElPortalDirective = (<any>(null as any));
var _decl0_10:i6.ElPortalOutletDirective = (<any>(null as any));
var _decl0_11:i7.ElOverlayContainerComponent = (<any>(null as any));
var _decl0_12:i8.ElCalendarComponent<any> = (<any>(null as any));
var _decl0_13:i9.ElCalendarRangeComponent<any> = (<any>(null as any));
var _decl0_14:i10.ElDatepickerDirective<any> = (<any>(null as any));
var _decl0_15:i11.ElDatepickerContainerComponent = (<any>(null as any));
var _decl0_16:i12.ElDatepickerComponent<any> = (<any>(null as any));
var _decl0_17:i12.ElRangepickerComponent<any> = (<any>(null as any));
var _decl0_18:i13.ElOverlayModule = (<any>(null as any));
var _decl0_19:i14.ElCalendarModule = (<any>(null as any));
var _decl0_20:i15.ElCalendarRangeModule = (<any>(null as any));
var _decl0_21:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_22:i0.ElementRef<any> = (<any>(null as any));
function _View_ElDatepickerContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_15.top;
  currVal_0;
  const currVal_1:any = _decl0_15.topStart;
  currVal_1;
  const currVal_2:any = _decl0_15.topEnd;
  currVal_2;
  const currVal_3:any = _decl0_15.right;
  currVal_3;
  const currVal_4:any = _decl0_15.endTop;
  currVal_4;
  const currVal_5:any = _decl0_15.endBottom;
  currVal_5;
  const currVal_6:any = _decl0_15.bottom;
  currVal_6;
  const currVal_7:any = _decl0_15.bottomStart;
  currVal_7;
  const currVal_8:any = _decl0_15.bottomEnd;
  currVal_8;
  const currVal_9:any = _decl0_15.left;
  currVal_9;
  const currVal_10:any = _decl0_15.startTop;
  currVal_10;
  const currVal_11:any = _decl0_15.startBottom;
  currVal_11;
}
function _View_ElDatepickerContainerComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_ElDatepickerComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ElDatepickerComponent_2_0():void {
  var _any:any = (null as any);
}
function _View_ElRangepickerComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_ElRangepickerComponent_3_0():void {
  var _any:any = (null as any);
}
